enum EventWebPageOGImageType {
  UseLogoAsSocialImage = 0,
  CustomSocialImage = 1,
}
export default Object.freeze(EventWebPageOGImageType);
